// extracted by mini-css-extract-plugin
export var formContainer = "_m1-0";
export var message = "_m1-1";